export const settings = {
  noImage: 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif',
  cartDrawer: {
    itemImageSize: '200x',
  },
  cartPage: {
    itemImageSize: '280x',
  },
  actionClasses: {
    hasItems: 'has-items',
    hidden: 'is-hidden',
    bodyClasses: 'is-drawer-open no-scroll',
    empty: 'is-empty',
    visible: 'is-visible',
    opened: 'is-opened',
    btnLoading: 'is-loading',
  },
  selectors: {
    body: 'body',
    add: '.js-ajax-add',
    cartDrawer: '#cart-drawer',
    cartHolder: '.js-cart-holder',
    cartToggleTrigger: '.js-cart-toggle-trigger',
    cartCount: '.js-cart-count',
    cartTrigger: '.js-cart-toggle-trigger',
  },
  templates: {
    cartDrawer: Shopify.theme.templates.cart_drawer,
    cartDrawerEmpty: Shopify.theme.templates.cart_drawer_empty,
    cartDrawerItem: Shopify.theme.templates.line_item,
    cartDrawerItemProperties: Shopify.theme.templates.line_item_properties,
    cartDrawerItemVariants: Shopify.theme.templates.line_item_variants,
    cartPageItem: Shopify.theme.templates.cart_item,
    cartPageItemProperties: Shopify.theme.templates.cart_item_properties,
    cartPageItemVariants: Shopify.theme.templates.cart_item_variants,
    cartPageItemsHolder: Shopify.theme.templates.cart_items_holder,
    cartPageItemsHolderEmpty: Shopify.theme.templates.cart_items_holder_empty,
  },
};
